import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule, NgModel, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";

@Component({
  selector: 'app-audit-trails-modal',
  standalone: true,
  imports: [
  MatDialogModule,
  CommonModule
],
  templateUrl: './audit-trails-modal.component.html',
  styleUrls: ['./audit-trails-modal.component.scss']
})
export class AuditTrailsModalComponent  {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any   ) {}
}